module.exports = __webpack_public_path__ + "static/ss49_sensor-7d7dd9d945e84b42dfa1391a4873bc42.webp";